import uniqueId from 'lodash/uniqueId';
import { useMemo } from 'preact/hooks';

export const useId = (count = 1, prefix = 'id-') => useMemo(() => Array.from({ length: count }, () => uniqueId(prefix)), [count, prefix]);

export default useId;